import { Link } from 'react-router-dom';
import { RouteNames } from '../components/AppRouter';

function AdminPage() {
    // .hero.is-fullheight .hero-body centre verticalement (align-items:center) :
    // le helper Bulma, qui porte !important, cale le contenu en haut.
    return (
        <div className="hero-body is-align-items-flex-start">
            <div className="container">
                <h1 className="title is-2">Administration</h1>
                <div className="content">
                    <p>Salle des coffres, réservée aux gardiens des clés.</p>
                </div>

                <div className="columns">
                    <div className="column is-half">
                        <Link to={RouteNames.adminSync} className="box">
                            <h3 className="title is-5">Synchronisations du catalogue</h3>
                            <p className="has-text-grey">
                                Ce que les dernières vagues d'import ont ajouté, mis à jour ou laissé de côté.
                            </p>
                        </Link>
                    </div>
                    <div className="column is-half">
                        <Link to={RouteNames.adminUsers} className="box">
                            <h3 className="title is-5">Utilisateurs</h3>
                            <p className="has-text-grey">
                                Consulter les comptes, modifier leurs informations, activer ou désactiver l'accès.
                            </p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminPage;
